import {db} from "@/firebase/init";
import md5 from "crypto-js/md5";

export default {
    methods: {
        async getSupportUser(users){
            try{
                console.log('inside support user', users)
                const userRef= await db.collection('users').where('userType', 'in', ['admin', 'manager']).where('department', '==','support').get();
                const supportUser=[]
                if(userRef.size){
                    userRef.forEach((value)=>{
                        supportUser.push({uid: value.id, ...value.data()})
                    })
                    console.log('support user', supportUser)
                    const result = [];
                    supportUser.forEach(obj1 => {
                        const matchingObject = users.find(obj2 => obj2.uid === obj1.uid);
                        if (matchingObject) {
                            result.push(matchingObject);
                        }
                    });
                    console.log(result)
                    return result;
                }
                else{
                    return []
                }
            }
            catch(e){
                console.log('Something went wrong with fetching users', e.toString())
            }

        },
        async getLowestAndHighestMigrationCount(users){
            console.log('inside get lowest and highest migration')
            const result = users.reduce(
                (acc, obj) => {
                    if (obj.migration > acc.max.migration) {
                        acc.max = obj;
                    }
                    if (obj.migration < acc.min.migration) {
                        acc.min = obj;
                    }
                    return acc;
                },
                { max: users[0], min: users[0] }
            );
            try{
                await this.$http.post('/slack/update-slack-status',{
                    grant_type: "token",
                    userWithMaxMigration: result.max , userWithMinMigration: result.min
                })
            }
           catch(e){
               console.log('Error while updating user slack status', e.toString())
           }
        },
        async incrementCountBasedOnType(currentUser, type, commentObj){
            try {
                console.log('inside the increment count func', 'type is', type)
                const date = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/New_York',}));
                const currentMonth = date.getMonth()
                const currentYear = date.getFullYear()
                console.log('current month', currentMonth);
                console.log('current year', currentYear);
                const ref = await db.collection('leaderboard').where('month', '==', currentMonth).where('year', '==', currentYear).get();
                if(ref.size) {
                    const { users } = ref.docs[0].data()
                    const id = ref.docs[0].id
                    // sort the array => before
                    let usersBefore = JSON.parse(JSON.stringify(users))
                    usersBefore = usersBefore.sort((a, b) => {
                        {
                            if (a[type] < b[type]) {
                                return 1
                            }
                            if (a[type] > b[type]) {
                                return -1
                            }
                            return 0
                        }
                    });
                    console.log('before user', usersBefore)
                    const beforeIndex = usersBefore.findIndex(el => el.uid === currentUser.uid);
                    console.log('before index of user', beforeIndex)
                    const requiredUser = users.find(el => el.uid === currentUser.uid)
                    if(requiredUser){
                        const prvResult = requiredUser[type] ? requiredUser[type]: 0;   // if key doesn't exist
                        requiredUser[type] = prvResult + 1;
                        const usersAfter = [...users].sort((a, b) => {
                            {
                                if (a[type] < b[type]) {
                                    return 1
                                }
                                if (a[type] > b[type]) {
                                    return -1
                                }
                                return 0
                            }
                        });
                        console.log('after user', usersAfter)
                        const afterIndex = usersAfter.findIndex(el => el.uid === currentUser.uid);
                        console.log('after index of user', afterIndex)
                        console.log('values of type', usersAfter[afterIndex][type], usersAfter[beforeIndex][type])
                        // console.log('condition 1', afterIndex < beforeIndex && usersAfter[afterIndex][type] > usersAfter[afterIndex + 1][type])
                        // console.log('condition 2', afterIndex > 0 && afterIndex === beforeIndex && usersAfter[afterIndex][type] > usersAfter[afterIndex + 1][type] && usersAfter[afterIndex - 1][type] !== usersAfter[afterIndex][type])
                        // console.log('condition 3', afterIndex === 0 && usersAfter[afterIndex][type] > usersAfter[afterIndex + 1][type])
                        if(afterIndex < beforeIndex && usersAfter[afterIndex][type] > usersAfter[afterIndex + 1][type]) {
                            console.log('inside slackmsg')
                            const taskType = type === 'cfEnterprise' ? 'Perf & Sec tasks' : type
                            let msg = `*${usersAfter[afterIndex].name}* overtook *${usersAfter[afterIndex + 1].name}* on ${taskType}!`;
                            let award = ''
                            if(afterIndex < 3){
                                if(afterIndex === 0) {
                                    award = 'Gold'
                                }
                                else if(afterIndex === 1) {
                                    award = 'Silver'
                                }
                                else {
                                    award = 'Bronze'
                                }
                            }
                            // send slack message
                            await this.$http.post('utilities/send-remarks-to-slack', {
                                grant_type: 'token',
                                msg,
                                award,
                                type: 'Overtook'

                            });
                        }
                        if(type === 'teamRemarks'){
                            requiredUser.teamRemarksDetails.push(commentObj)
                        }
                    }
                    else {
                        const statsObj = {
                            migration: 0,
                            review: 0,
                            support: 0,
                            monitor: 0,
                            teamRemarks: 0,
                            customerRemarks: 0,
                            cfEnterprise: 0,
                            teamRemarksDetails: [],
                            customerRemarksDetails: [],
                            uid: currentUser.uid,
                            email: currentUser.email,
                            emailHash: currentUser.email ?  md5(currentUser.email.trim().toLowerCase()).toString() : '',
                            name: currentUser.firstName + ' ' + currentUser.lastName,
                        }
                        statsObj[type] = 1
                        if(type === 'teamRemarks'){
                            statsObj.teamRemarksDetails.push(commentObj)
                        }
                        users.push(statsObj)
                    }
                    await db.collection('leaderboard').doc(id).update({users})
                    if(type === 'migration' ){
                        console.log('line 156')
                        const filtererUsers=await this.getSupportUser(users);
                        if(filtererUsers.length > 1){
                            await this.getLowestAndHighestMigrationCount(users)
                        }
                        else{
                            console.log('line 163', filtererUsers)
                            try {
                                await this.$http.post('/slack/update-slack-status',{
                                    grant_type: "token",
                                    userWithMaxMigration: filtererUsers[0],
                                    userWithMinMigration: null,
                                    // userWithMinMigraztion: {}
                                })
                            } catch (e) {
                                console.log('error from update slack status', e.toString())
                            }

                        }
                    }
                }
                else {
                    const users = []
                    const obj = {
                        migration: 0,
                        review: 0,
                        support: 0,
                        monitor: 0,
                        teamRemarks: 0,
                        customerRemarks: 0,
                        cfEnterprise: 0,
                        teamRemarksDetails: [],
                        customerRemarksDetails: [],
                        uid: currentUser.uid,
                        email: currentUser.email,
                        emailHash: currentUser.email ?  md5(currentUser.email.trim().toLowerCase()).toString() : '',
                        name: currentUser.firstName + ' ' + currentUser.lastName,
                    }
                    obj[type] = 1
                    if(type === 'teamRemarks'){
                        obj.teamRemarksDetails.push(commentObj)
                    }

                    users.push(obj)
                    const statsObj = {
                        month: currentMonth,
                        year: currentYear,
                        users,
                    }
                    await db.collection('leaderboard').add(statsObj)
                    if(type === 'migration' && obj.migration > 0){
                        console.log('line 199')
                        try{
                            await this.$http.post('/slack/update-slack-status',{
                                grant_type: "token",
                                userWithMaxMigration: obj , userWithMinMigration: {}
                            })
                        }
                        catch(e){
                            console.log('Error while updating user slack status', e.toString())
                        }
                    }
                }
                // save data for all time document in leaderboard
                const allTimeStatsRef = await db.collection('leaderboard').doc('all-time-leaderboard').get();
                if(allTimeStatsRef.exists) {
                    const { users } = allTimeStatsRef.data();
                    const requiredUser = users.find(el => el.uid ===  currentUser.uid)
                    if(requiredUser) {
                        const prevResult = requiredUser[type] ? requiredUser[type] : 0;
                        requiredUser[type] = prevResult + 1;
                        if(type === 'teamRemarks'){
                            requiredUser.teamRemarksDetails.push(commentObj)
                        }
                    }else {
                        const statsObj = {
                            migration: 0,
                            review: 0,
                            support: 0,
                            monitor: 0,
                            teamRemarks: 0,
                            customerRemarks: 0,
                            cfEnterprise: 0,
                            teamRemarksDetails: [],
                            customerRemarksDetails: [],
                            uid: currentUser.uid,
                            email: currentUser.email,
                            emailHash: currentUser.email ?  md5(currentUser.email.trim().toLowerCase()).toString() : '',
                            name: currentUser.firstName + ' ' + currentUser.lastName,
                        }
                        statsObj[type] = 1
                        if(type === 'teamRemarks'){
                            statsObj.teamRemarksDetails.push(commentObj)
                        }
                        users.push(statsObj)
                    }
                    await db.collection('leaderboard').doc('all-time-leaderboard').update({users})
                }
                else{
                    const users = []
                    const obj = {
                        migration: 0,
                        review: 0,
                        support: 0,
                        monitor: 0,
                        teamRemarks: 0,
                        customerRemarks: 0,
                        cfEnterprise: 0,
                        teamRemarksDetails: [],
                        uid: currentUser.uid,
                        email: currentUser.email,
                        emailHash: currentUser.email ?  md5(currentUser.email.trim().toLowerCase()).toString() : '',
                        name: currentUser.firstName + ' ' + currentUser.lastName,
                    }
                    obj[type] = 1
                    if(type === 'teamRemarks'){
                        obj.teamRemarksDetails.push(commentObj)
                    }
                    users.push(obj)
                    await db.collection('leaderboard').doc('all-time-leaderboard').set({users})
                }
            }
            catch (e) {
                console.log('error on line 107 in statistics panel', e.toString())
            }
        }
    }
}
